import React from 'react';

import { DeckAPI, DeckValue, Stamp, StampIcon } from '@philips-emr/tws-components';
import { Color } from '@philips-emr/tws-constants';
import Controller, { OnDynamicContentRender, OnMount, OnSelectItem, OnUnmount } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';

import { FragmentNames } from '../../codegen';
import { HistoricoAutorizacoesAliases } from '../../codegen/constants/aliases/historico-autorizacoes-aliases';
import { Routes } from '../../definitions/routes';
import FilterService from '../../services/filter-service';
import BaseController from '../base/base-controller';

@Controller({ fragment: FragmentNames.HISTORICO_AUTORIZACOES })
export default class HistoricoAutorizacoesController extends BaseController {

  @OnMount(HistoricoAutorizacoesAliases.FILTER)
  onFilterMount = (event: MountEvent): void => FilterService.restoreFilterState(event);

  @OnUnmount(HistoricoAutorizacoesAliases.FILTER)
  onFilterUnmount = (event: MountEvent): void => FilterService.persistFilterState(event);

  @OnDynamicContentRender(HistoricoAutorizacoesAliases.CUSTOM_CARD)
  onDynamicContentRender({ data, render }: RenderEvent): void {
    const { ieStatus } = data as { ieStatus: number };

    const props: { [key: number]: {} } = {
      1: { icon: StampIcon.CHECK, color: Color.SAFETY_GREEN },
      2: { icon: StampIcon.CLOCK, color: Color.SAFETY_ORANGE },
      3: { icon: StampIcon.CANCELED, color: Color.SAFETY_RED },
    };

    render(() => <Stamp {...props[ieStatus]} label={`@beneficiary.status-guia-autorizacao/${ieStatus}`} />);
  }

  @OnSelectItem(HistoricoAutorizacoesAliases.DECK)
  onSelectItem({ item, target }: SelectItemEvent<DeckValue>): void {
    const api = target as DeckAPI;
    api.unselectAll();

    const { nrSequencia } = item;
    this.historyService.push(Routes.DETALHES_AUTORIZACAO, { nrSeqGuia: nrSequencia as string });
  }
}
